export function SkeletonTable() {
  return (
    <div
      role="status"
      aria-label="Loading insider transactions"
      aria-busy="true"
      className="min-h-0 flex-1 overflow-hidden border border-border bg-surface"
    >
      <span className="sr-only">Loading validated canonical dashboard data</span>
      <table
        aria-label="Loading insider transaction table"
        className="w-full min-w-[940px] border-collapse text-left text-xs"
      >
        <thead className="bg-surface-elevated text-[10px] uppercase text-muted-foreground">
          <tr>
            {["Favorite", "Ticker", "Company", "Insider", "Activity", "Value", "Ownership", "Dates", "Score"].map(
              (heading) => (
                <th key={heading} className="border-b border-border px-3 py-2 font-semibold">
                  {heading}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 7 }, (_, rowIndex) => (
            <tr key={rowIndex} aria-hidden="true" className="border-b border-border">
              {Array.from({ length: 9 }, (_, cellIndex) => (
                <td key={cellIndex} className="px-3 py-3">
                  <div className="h-2.5 rounded-sm bg-surface-elevated" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
